import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  section: {
  },
  container: {
    display: 'flex',
    '@media (max-width: 768px)': {
      display: 'block'
    },
  },
  itemContainer: {
    width: '50%',
    '@media (max-width: 768px)': {
      width: 'auto',
      padding: '60px'

    },
  },
  leftContainer: {
    paddingRight: '60px',
    width: '60%',
    marginLeft: 'auto',
    paddingTop: '60px',
    paddingBottom: '60px',
    '@media (max-width: 768px)': {
      width: '100%',
      padding: '0px'
    },
  },
  rightContainer: {
    backgroundColor: '#1356DA',
    display: 'flex',
    alignItems: 'center',
    width: '50%',
    '@media (max-width: 768px)': {
      width: '100%',
    },
  },
  heading: {
    textAlign: 'left',
    marginBottom: '20px',
    marginTop: '0',
    color: '#1356DA',
    fontSize: '46px',
    fontWeight: '700',
    "@media (max-width: 1540px)": {
      fontSize: '44px',
    },
    "@media (max-width: 1280px)": {
      fontSize: '42px',
    },
    "@media (max-width: 1023px)": {
      fontSize: '40px',
    },
    "@media (max-width: 768px)": {
      fontSize: '38px',
    },
    "@media (max-width: 600px)": {
      fontSize: '36px',
    },
    "@media (max-width: 480px)": {
      fontSize: '32px',
    },
  },
  imageContainer: {
    textAlign: 'center',
    '@media (min-width: 768px)': {
      paddingRight: '30px'
    },
  },
  image: {
    width: '100%',
    '@media (max-width: 768px)': {
      width: 'auto'
    },
  },
  button: {
    marginTop: '20px !important',
    textTransform: 'none !important',
    color: '#1356DA !important',
    fontWeight: 'bold !important',
    backgroundColor: 'white !important',
    border: '1px solid white !important',
    '&:hover': {
      backgroundColor: 'transparent !important',
      color: 'white !important',
    }
  },
  captcha: {
    marginTop: '20px'
  },
  formContainer: {
    width: '100%',
    paddingLeft: '15px',
    paddingRight: '15px',
    color: 'white',
    '@media (min-width: 768px)': {
      width: '60%',
      paddingLeft: '60px',
      paddingRight: '0px'
    },
    '@media (max-width: 769px)': {
      padding: '60px'
    },
  },
  customTextField: {

    '& .MuiOutlinedInput-root': {
      marginBottom: '15px',
      marginTop: '10px',
      '& fieldset': {
        borderColor: '#ffffff', // Color del borde por defecto
      },
      '&:hover fieldset': {
        borderColor: '#ffffff', // Color del borde cuando se pasa el mouse
      },
      '&.Mui-focused fieldset': {
        borderColor: '##ffffff', // Color del borde cuando el campo está enfocado
      },

    },
    '& .MuiInputBase-input': {
      color: '#ffffff', // Color del texto
    },
    // Estilos cuando hay un error
    '& .MuiFormHelperText-root': {
      color: '#FF4081', // Color del texto de error
    },
    '& .MuiOutlinedInput-root.Mui-error': {
      '& fieldset': {
        borderColor: '#FF4081', // Color del borde cuando hay un error
      },
    },
  },
});

export default useStyles;